import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-ms-demographic-location-table",
	templateUrl: "./ms-demographic-location-table.component.html",
	styleUrls: ["./ms-demographic-location-table.component.css"],
})
export class MsDemographicLocationTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateFilters();
	}

	ngOnChanges() {
		this.UpdateFilters();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedFacilityLocation: any;

	@Input() lstFacilityLocation: any = [];
	@Input() loading: boolean = false;

	lstFacilityName: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FacilityLocationName", header: "Location" },
		{ field: "FacilityName", header: "Facility" },
		{ field: "ScanCount", header: "Scan Count" },
	];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateFilters() {
		this.lstFacilityName = Array.from(new Set(this.lstFacilityLocation.map((item: any) => item.FacilityName))).sort();
	}

	////////////////////////////////////////////
}
